<template>
  <Header />
  <div style="width: 90%; margin: auto; margin-top: 1rem">
    <router-view></router-view>
  </div>
  <Footer />
</template>

<script>
import Header from "./components/TheHeader.vue";
import Footer from "./components/TheFooter.vue";

export default {
  name: "App",
  data: function () {
    return {
      appConfig: {
        documentType: "Socotra_Document",
        cordraUrl: "https://scsdp.senckenberg.de/cordra/",
        //cordraUrl: "http://localhost:8088/",
      },
    };
  },
  components: {
    Header,
    Footer,
  },

  provide: function () {
    return {
      appConfig: this.appConfig,

      keycloakProperties: {
        ready: false,
        authenticated: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
// There're widgets, who was themed for special reasons
::v-deep(.dataDocumentsPanel.p-panel) {
  .p-panel-header,
  .p-panel-content {
    border-width: 2px;
    border-color: rgb(184, 172, 172);
  }
}

::v-deep(.dataDocumentsPanel.p-panel) {
  .p-panel-header {
    font-weight: bold;
  }
}

::v-deep(.dataDocumentsPanel.p-panel) {
  .p-panel-content {
    font-weight: 700;
  }
}
</style>

<style lang="scss">
body {
  background-image: url("./assets/bg.jpeg");
  background-repeat: no-repeat;
  background-size: inherit;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: white;
  opacity: 0.8;
}

// Widgets
.fieldsetBorder {
  border-width: 2px !important;
  border-color: rgb(184, 172, 172) !important;
}

.p-inputtext {
  border-width: 2px;
  border-color: rgb(184, 172, 172);
}

// Text
a {
  color: black;
  font-weight: bold;
}

.dataDocumentsPanelContent {
  font-weight: 500;
}

// Margins
.dataDocuments {
  margin-top: 1rem;
}

// Icons
span.icon-orcidid {
  /* Example:
  <a href="" target="_blank">
    <span class="icon-orcidid"> </span>
    My Text here</a> */
  background: url(./assets/icons/orcidid_icon.svg) bottom left no-repeat;
  background-size: contain;
  display: inline-block;
  position: relative;
  width: 1rem;
  height: 1rem;
}
</style>
